import type { IconProps } from '../types/IconProps.ts';
export const Upload: IconProps = {
    name: 'Upload',
    children: [
        `<path d="M3 14v5c0 1.1.9 2 2 2h14a2 2 0 0 0 2-2v-5M7 8l4.65-4.65c.2-.2.5-.2.7 0L17 8M12 4v11" />`,
    ]
};